const YthKeyword = (() => {
    $('#heading_keyword_dt').DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        ordering: true,
        searching: true,
        pageLength: 25,
        order: [[ 0, 'asc' ],[ 1, 'asc' ]],
        orderMulti: true,

        ajax: {
            url : '/admin/heading-keywords/listing',
            type : 'POST'
        },
        columns: [
            {data: 'heading', name: 'headings.heading_name'},
            {data: 'keyword_name', name: 'keyword_name'},
            {
                data: 'action', 
                name: 'action',
                orderable: true, 
                searchable: true
            },
        ]
    });

    $(document).on('keyup', '.select2-search__field', function(e){
        // e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
        const arr = e.target.value.split(" ");

        //loop through each element of the array and capitalize the first letter.


        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);

        }

        //Join all the elements of the array back into a string 
        //using a blankspace as a separator 
        e.target.value = arr.join(" ");
    });

    //delete headings keywords
    $(document).on('click', '#delete-heading-keyword', function (event) {
        const id = $(event.currentTarget).data('id');
        var option_id = $(this).data("id");

        Swal.fire({
            icon: 'error',
              title: 'Do you want to delete?',
              showCancelButton: true,
              confirmButtonText: 'Delete',
              denyButtonText: `Cancel`,
            }).then((result) => {
              if (result.isConfirmed) {
                  $.ajax({
                      type: "POST",
                      data: {_method: 'delete'},
                      url: baseUrl + "/admin/heading-keywords/"+id,
                      success: function (data) {
                          var oTable = $('#heading_keyword_dt').dataTable();
                          oTable.fnDraw(false);
                          Swal.fire(data.message, '', 'success');
                      },
                      error: function (data) {
                          Swal.fire(data.responseJSON.message, '', 'error');
                      }
                  });
                
              }
            });
    }); 

    
    $(document).on('click', '.add-more-keyword', function (event) {
        let html = '<div class="form-group mb-3"><div class="row"><div class="col-md-11"><label for="keyword_name">Keyword Name</label><input class="form-control" placeholder="Keyword Name" name="keyword_name[]" type="text"></div><div class="col-md-1 mt-1 text-end"><button type="button" class="btn btn-danger btn-sm mt-3 remove-keyword">Remove</button></div></div></div>';
        $('#keywordDiv').append(html);
        if($('.remove-keyword').length > 0){
            $('.remove-keyword:first').removeClass('d-none');
        }
    });

    $(document).on('click', '.remove-keyword', function (event) {
        $(this).parent().parent().parent().remove();
        if($('.remove-keyword').length == 1){
            $('.remove-keyword:first').addClass('d-none');
        }
        else{
            $('.remove-keyword:first').removeClass('d-none');
        }
    });
    
    $( document ).ready(function() {
        // alert("here"); 
        // call validation  function etc
    });

});

export default YthKeyword;
